import { KMSClient, EncryptCommand } from '@aws-sdk/client-kms';
import { toBase64 } from '@aws-sdk/util-base64-browser';
import envConfig from 'env/EnvConfig';
import { getKmsCredentials } from 'utils/aws-kms-credentials';

const awsKey = envConfig.AWS_KMS_KEY;
const region = envConfig.AWS_PROJECT_REGION;

let _kmsClient = null;
let _kmsClientKey = '';

function getKMSClient(credentials) {
  const key = `${credentials.accessKeyId}:${credentials.sessionToken || ''}`;
  
  if (_kmsClient && _kmsClientKey === key) {
    return _kmsClient;
  }

  _kmsClient = new KMSClient({
    region,
    credentials: {
      accessKeyId: credentials.accessKeyId,
      secretAccessKey: credentials.secretAccessKey,
      sessionToken: credentials.sessionToken
    }
  });
  
  _kmsClientKey = key;
  return _kmsClient;
}

async function encrypt(buffer1) {
  if (!buffer1) {
    return null;
  }

  const kmsCredentials = await getKmsCredentials();

  if (!kmsCredentials?.accessKeyId || !kmsCredentials?.secretAccessKey) {
    throw new Error('No AWS credentials from Amplify. Ensure Amplify.configure has run and Auth.Cognito.identityPoolId is set. If using authenticated creds, call after sign-in.');
  }

  const kms = getKMSClient(kmsCredentials);
  
  const params = {
    KeyId: awsKey,
    EncryptionAlgorithm: 'SYMMETRIC_DEFAULT',
    Plaintext: buffer1 instanceof Uint8Array ? buffer1 : new TextEncoder().encode(buffer1)
  };

  try {
    const command = new EncryptCommand(params);
    const response = await kms.send(command);
    return toBase64(response.CiphertextBlob);
  } catch (error) {
    console.error('Error encrypting data:', error);
    throw error;
  }
}

export default encrypt;

